<template>
  <div id="loading" :class="pageType=='app'?'loading_app':''">
    <div v-if="pageType=='app'"><img src="@/assets/images/template/loading.gif"></div>
    <div v-else>
      <img src="@/assets/images/template/loading.gif">
      <span>数据正在加载中...</span>
    </div>
  </div>
</template>

<script>
import api from '@/plugins/api'
import { mapState } from 'vuex'
import { errorMap } from '@/utils/helper'
export default {
  name: 'Token',
  computed: {
    ...mapState(['pageType'])
  },
  created() {
    // 通过token获取用户账号，再跳转
    api.getCacheCustomerByToken(this.$route.query.loginToken).then(res => {
      if (res.data.code == 200 && res.data.code_desc == 'success') {
        // 获取token成功,保存用户信息，并跳转到对应的页面
        const data = res.data.data
        const user = {
          loginname: data.customerNumber,
          pwd: data.encryption,
          companyId: data.companyId,
          mobilePhone: data.mobilePhone
        }
        this.$store.dispatch('setGts2AccountId', data.gts2AccountId)
        this.$store.dispatch('setGts2CustomerId', data.gts2CustomerId)
        this.$store.dispatch('setUser', user)
        this.$router.replace({ path: this.$route.query.url, query: this.$route.query.query })
      }
    }).catch(() => {
      this.$toast.fail(errorMap.getCacheCustomerByToken)
    })
  }
}
</script>
